const API_BASE = process.env.REACT_APP_BACKEND_URL;

/**
 * Resolve an image path from the database to a full URL.
 * DB stores paths like "/api/uploads/..." or "/api/storage/..." which need the backend URL prepended.
 */
export function getImageUrl(path) {
  if (!path) return null;
  if (path.startsWith("/api/")) return `${API_BASE}${path}`;
  return path;
}

/**
 * Extract up to 2-letter initials from a name.
 * "John Doe" → "JD", "Priya" → "PR", "A" → "A"
 */
export function getInitials(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
}
